<script>
</script>

<button
    class="sm:w-40 inline-flex items-center justify-center px-5 py-2 border border-transparent text-base text-sm md:text-lg rounded-md text-white bg-indigo-600 hover:bg-indigo-700">Continue</button>
